'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { formatNumberAsCurrencyString } from '@sola/cart-sdk/utils/amount.ts';
import { FieldProps } from '../field/field.tsx';
import { InputField, InputFieldProps } from '../input-field/input-field.tsx';
export type NumberFieldProps = InputFieldProps & {
  max?: FieldProps['max'];
  min?: FieldProps['min'];
  isCurrency?: boolean;
  allowScientific?: boolean;
};
export const NumberField: React.FC<NumberFieldProps> = t0 => {
  const $ = _c(15);
  let allowScientific;
  let fieldProps;
  let t1;
  if ($[0] !== t0) {
    ({
      isCurrency: t1,
      allowScientific,
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = allowScientific;
    $[2] = fieldProps;
    $[3] = t1;
  } else {
    allowScientific = $[1];
    fieldProps = $[2];
    t1 = $[3];
  }
  const isCurrency = t1 === undefined ? true : t1;
  const {
    name
  } = fieldProps;
  const {
    setValue,
    getValues
  } = useFormContext();
  let t2;
  if ($[4] !== getValues || $[5] !== isCurrency || $[6] !== name || $[7] !== setValue) {
    t2 = () => {
      if (!name) {
        return;
      }
      const value = getValues()[name];
      if (isCurrency && value) {
        setValue(name, formatNumberAsCurrencyString(value));
      }
    };
    $[4] = getValues;
    $[5] = isCurrency;
    $[6] = name;
    $[7] = setValue;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== allowScientific) {
    t4 = !allowScientific && {
      illegalCharsRegex: /[e|E|+|-]/g,
      onKeyDown: _temp
    };
    $[10] = allowScientific;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== fieldProps || $[13] !== t4) {
    t5 = <InputField valueAsNumber={true} type="number" {...t4} {...fieldProps} />;
    $[12] = fieldProps;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
function _temp(e) {
  if (["e", "E", "+", "-"].includes(e.key)) {
    e.preventDefault();
  }
}